export const MAX_NAME_LENGTH = 40;
export const MAX_WORKSPACE_NAME_LENGTH = 90;
